import { ref, computed } from 'vue'
import { createApiHeaders } from '../config/cvConfig.js'

const subscription = ref({
  plan: 'free',
  status: 'active',
  is_pro: false,
  cv_limit: 3,
  cv_count: 0,
  current_period_end: null,
  cancel_at_period_end: false
})

export function useSubscription() {
  const isPro = computed(() => subscription.value.is_pro)
  const cvLimit = computed(() => subscription.value.cv_limit)
  const cvCount = computed(() => subscription.value.cv_count)
  const cvLimitReached = computed(() =>
    cvLimit.value !== null && cvCount.value >= cvLimit.value
  )
  const cvSlotsRemaining = computed(() =>
    cvLimit.value === null ? null : Math.max(0, cvLimit.value - cvCount.value)
  )

  function setSubscription(data) {
    if (data) subscription.value = { ...subscription.value, ...data }
  }

  function incrementCvCount() {
    subscription.value.cv_count = (subscription.value.cv_count || 0) + 1
  }

  function decrementCvCount() {
    subscription.value.cv_count = Math.max(0, (subscription.value.cv_count || 0) - 1)
  }

  async function openCheckout() {
    const response = await fetch('/api/stripe/checkout_session', {
      method: 'POST',
      headers: createApiHeaders()
    })
    const data = await response.json()
    if (data.url) window.location.href = data.url
  }

  async function openPortal() {
    const response = await fetch('/api/stripe/portal_session', {
      method: 'POST',
      headers: createApiHeaders()
    })
    const data = await response.json()
    if (data.url) window.location.href = data.url
  }

  return {
    subscription,
    isPro,
    cvLimit,
    cvCount,
    cvLimitReached,
    cvSlotsRemaining,
    setSubscription,
    incrementCvCount,
    decrementCvCount,
    openCheckout,
    openPortal
  }
}
